import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';
import {
  SUPPORT_INFO_SENTINEL_ID,
  SupportInfo,
  supportInfoClient,
} from 'common/report/queries/app-api/support-info-client';

export class SupportInfoResource extends ApiSingleValueResource<SupportInfo> {
  apiClient = supportInfoClient;

  constructor() {
    super();
    this.id = SUPPORT_INFO_SENTINEL_ID;
  }
}
